// @flow

import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';

import store from './store/index';
import { history } from './router/index';

import App from './App';
import './index.css';

import { ErrorBoundary } from '@sentry/react';
import Loading from './components/Loading';

// console.log = () => {};
// console.warn = () => {};
// console.error = () => {};
// console.debug = () => {};

const container = document.getElementById('root');
const root = createRoot(container);

if (root) {
    root.render(
        <Provider store={store}>
            <ErrorBoundary fallback={<Loading />}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </ErrorBoundary>
        </Provider>
    );
}
